import React, { useEffect, useState } from 'react';
import {
    CircularProgress,
    Grid, Typography
} from "@material-ui/core/";
import { Link } from 'react-router-dom';

import FormBase from '../../../../forms/FormBase';
import Controls from '../../../../components/controls/Controls';
import RefusalPresentVaccineTermItem from './RefusalPresentVaccineTermItem';
import RefusalPresentVaccineForm, { RefusalPresentVaccineItem } from '../../../../forms/shared/termsDeclarations/RefusalPresentVaccineForm';
import TermsDeclarationsService from '../../../../services/TermsDeclarationsService';
import TermsDeclarations from '../../../../models/TermsDeclarations';
import { ModalHandle } from '../../../../components/controls/Modal';
import TmpHtmlContentCustom from '../../../../components/tempo/TmpHtmlContentCustom/TmpHtmlContentCustom';

interface RefusalPresentVaccineTermProps {
    Name: string;
    RefusalPresentVaccineForm: RefusalPresentVaccineForm;
    Checked: boolean;
    onInputChange: (name: string, form: FormBase, value: any) => void
    onCheckedClick: (e: any) => void
    onInputRefusalPresentVaccineItemChange: (name: string, form: FormBase, value: any, item: RefusalPresentVaccineItem) => void
}

export default function RefusalPresentVaccineTerm(props: RefusalPresentVaccineTermProps) {

    const modalRef = React.createRef<ModalHandle>();

    const handleOpenModalChild = () => {
        modalRef.current?.handleOpen()
    };

    const [checkedTerm, setCheckedTerm] = useState(props.Checked);

    const [text1, setText1] = useState<string>("")
    const [text2, setText2] = useState<string>("")
    const [title, setTitle] = useState<string>("")
    const [id, setId] = useState<number>(0)

    useEffect(() => {

        TermsDeclarationsService.getCurrentTermsDeclarations("TERMO_RECUSA_APRESENTAR_COMPROV_VACINAL").then(e => {

            if (e) {
                let textTerm: string = e.description;

                var text1 = textTerm.split('#{props.Component}')[0]
                var text2 = textTerm.split('#{props.Component}')[1]

                text1 = text1.replace("#{props.Name}", props.Name)

                setText1(text1)
                setText2(text2)
                setTitle(e.title)
                setId(e.textId);
            }
        })

    }, [props.Name])


    const handleCheckdTerm = (e: any) => {
        setCheckedTerm(e.target.value);
        props.onCheckedClick(new TermsDeclarations(id, e.target.value));
    }

    return (
        <Grid item xs={12} sm={12}>
            {
                id === undefined || id === 0 ?
                    <Grid container justifyContent="center" style={{ width: "85%" }} >
                        <CircularProgress />
                    </Grid>
                    :

                    <Controls.Checkbox
                        name="RefusalPresentVaccineTerm"
                        labelComponent={
                            <div>
                                <span>Li e estou de acordo com o  </span>
                                <Link to={'#'} onClick={() => handleOpenModalChild()}>Termo de Recusa em Apresentar Comprovação Vacinal.</Link>
                            </div>
                        }
                        value={checkedTerm}
                        onChange={handleCheckdTerm}
                    />
            }


            <Controls.Modal ref={modalRef} title={title}>

                <Typography variant="body1" gutterBottom component="div">

                    <TmpHtmlContentCustom html={text1} />

                    {props.RefusalPresentVaccineForm.RefusalPresentVaccineTermItemList.map((item, index) => (
                        <RefusalPresentVaccineTermItem key={index} RefusalPresentVaccineItem={item} onInputChange={(name: string, value: any) => { props.onInputRefusalPresentVaccineItemChange(name, props.RefusalPresentVaccineForm, value, item) }}></RefusalPresentVaccineTermItem>
                    ))}

                    <TmpHtmlContentCustom html={text2} />
                </Typography>

            </Controls.Modal>
        </Grid>
    );
}

